import {z} from '@hono/zod-openapi';

export const resetEquipmentMappingRemediationBatchRequestSchema = z
  .object({
    remediationIds: z.array(z.string().uuid()).min(1).max(10_000),
  })
  .openapi('ResetEquipmentMappingRemediationBatchRequest');
